<template>
  <div class="content" id="people-detail">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper">
      <div class="left">
        <div class="block"><PeopleForm></PeopleForm></div>
      </div>
    </div>
  </div>
</template>

<script>
import { PeopleForm } from './components'
export default {
  name: 'PeopleNew',
  components: {
    PeopleForm
  }
}
</script>
